<template lang="html">
  <booking-layoutview
    v-bind="$attrs"
    :createNewEvent="createNewEvent"
  >

    <template v-slot:summary="{eventsInRange}">
      Guests {{eventsInRange.reduce((acc, event) => acc + event.guests, 0)}} ({{eventsInRange.reduce((acc, event) => acc + event.guests_children, 0)}})
    </template>

    <template v-slot:event-item="slotProps">
      <booking-event-item
        v-bind="slotProps"
        @click="slotProps.onClick"
      ></booking-event-item>
    </template>

    <template v-slot:eventForm="slotProps">
      <booking-event-form
        v-bind="slotProps"
        @input="slotProps.onInput"
      ></booking-event-form>
    </template>

    <template v-slot:layout-grid="slotProps">
      <layout-grid
        v-bind="slotProps"
        @resourceClick="slotProps.onResourceClick"
      ></layout-grid>
    </template>

  </booking-layoutview>
</template>

<script>
import {BookingLayoutview} from 'dync-booking'
import BookingEventForm from './BookingEventForm.vue';
import BookingEventItem from './BookingEventItem.vue';
import LayoutGrid from './LayoutGrid.vue';

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  methods: {
    createNewEvent() {
      return {
        guests_children: 0,
        status: 'confirmed'
      };
    }
  },
  components: {
    BookingLayoutview,
    LayoutGrid,
    BookingEventForm,
    BookingEventItem
  }
}
</script>

<style lang="scss" scoped>
</style>
